export function redirectToUrl(url?: string): void {
  if (!url) {
    return;
  }

  window.location.replace(url);
}
